// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","594":"about"}[chunkId] + "." + {"53":"76b1d80b","594":"89fd20a1"}[chunkId] + ".js";
};